import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';

import { setState, stateSubscribe } from './lib/state'
import getInitialState from './initial-state'

const root = document.getElementById('root')

stateSubscribe(state => {
  const RootComponent = App

  ReactDOM.hydrate(
    <RootComponent {...state} />,
    root
  )
})

let language = window.location.pathname.startsWith('/en') ? 'en' : 'fi'
setState(Object.assign({}, getInitialState(), { language }))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
